import { Col, Row } from 'antd';

import { useDispatch, useSelector } from 'react-redux';
import {
  actions,
} from 'Slice/ServiceLinesSlice';
import classNames from 'classnames';
import { Article } from 'Types/ArticleTypes';
import InfiniteScroll from 'react-infinite-scroll-component';
import ArticleLoadingSkeletonBundle from 'Components/common/skeleton/ArticleLoadingSkeletonBundle';
import { Filter } from 'Types/FilterTypes';

import {
  selectNewsLoading,
  selectPaginationLoader,
  selectServicelineSelectedRegions,
  selectServicelineWidgets, selectWidgetLoading,
} from 'Selector/ServiceLinesSelector';
import NoDataFound from 'Components/common/components/NoDataFound';
import { NODATABASEDONFILTERS, NODATAFOUND } from 'Utils/Constants';
import ArticleListLoadingSkeletonBundle from 'Components/common/skeleton/ArticleListLoadingSkeletonBundle';
import { Widget } from 'Types/ServiceLinesTypes';
import ArticleGridLayout from 'Components/common/components/ArticleGridLayout';
import { SRIFiltersRequest } from '../../Types/SRITypes';
import { selectKPMGFlag } from '../../Selector/GlobalSearchContentSelector';
import { useEffect, useState, useRef } from 'react';

type Props = {
  id: number,
  widgetName: string
  listview: boolean;
  dateRangeFilter?: SRIFiltersRequest;
  pageLoading?: boolean
  customFilters: Filter[]
} & typeof defaultProps;

const defaultProps = {
  id: 0,
  listview: false,
  pageLoading: false,
};

const NewsTab = function NewsTab(props: Props) {
  const { id, listview, widgetName, dateRangeFilter, pageLoading, customFilters } = props;
  const serviceLineWidgets: Widget[] = useSelector(selectServicelineWidgets);
  const widget = serviceLineWidgets.find(((w) => w.title === widgetName));
  const dispatch = useDispatch();
  const loading: boolean = useSelector(selectWidgetLoading);
  const loadingNews: boolean = useSelector(selectNewsLoading);
  const isPagination: boolean = useSelector(selectPaginationLoader);
  const KPMGFlag = useSelector(selectKPMGFlag);
  const selectedFilters: Filter[] = widget?.selectedFilters || [];
  const articleEnded: boolean = widget?.articleEnded || false;
  const [detailsTriggered, setDetailsTriggered] = useState(false);
  const shouldBlockArticles = KPMGFlag && (!detailsTriggered || loadingNews || widget?.page === 1);
  const articles: Article[] = shouldBlockArticles ? [] : widget?.news || [];
  const kpmgLoad = KPMGFlag && (!detailsTriggered || loadingNews || widget?.page === 1);
  const fetchingRef = useRef(false);
  const selectedRegions = useSelector(selectServicelineSelectedRegions);

  useEffect(() => {
    if (loadingNews) {
      setDetailsTriggered(true);
    }
  }, [loadingNews]);

  useEffect(() => {
    if (!loadingNews && !isPagination) {
      fetchingRef.current = false;
    }
  }, [loadingNews, isPagination]);

  const fetchArticles = () => {
    if (fetchingRef.current) {
      return;
    }
    const currentWidget =
      serviceLineWidgets.find(((w) => w.title === widgetName));

    let nextPage = 1;
    if (currentWidget?.page) {
      if (currentWidget.page === 1 && articles.length > 0) {
        nextPage = 2;
      } else {
        nextPage = currentWidget.page;
      }
    } else if (articles.length > 0) {
      nextPage = 2;
    }

    fetchingRef.current = true;
    const subRegions = selectedRegions.join(",");
    const params = {
      page: nextPage,
      id,
      widget_name: widgetName,
      ...(selectedFilters.length > 0 && { filters: selectedFilters }),
      ...(dateRangeFilter && { dateRangeFilter }),
      ...(KPMGFlag && { kpmgMode: true }),
      ...(subRegions && { regions: subRegions }),
      ...(customFilters.length > 0 && { customFilters })
    };
    dispatch(actions.getServiceLineDetails(params));
  };

  const fetchMore = () => {
    if (articles.length > 0 && !articleEnded) {
      fetchArticles();
    }
  };

  if (kpmgLoad) {
    return (
      <Row gutter={[16, 16]} id="tabs-details">
        {listview ? (
          <ArticleListLoadingSkeletonBundle />
        ) : (
          <ArticleLoadingSkeletonBundle />
        )}
      </Row>
    )
  }
  if (loading || loadingNews) {
    return (
      <Row gutter={[16, 16]} id="tabs-details">
        {listview ? (
          <ArticleListLoadingSkeletonBundle />
        ) : (
          <ArticleLoadingSkeletonBundle />
        )}
      </Row>
    );
  }
  return (
    <div className={classNames({ serviceLineArticles: KPMGFlag })}>
      <div id="tabs-details">
        <InfiniteScroll
          dataLength={articles.length}
          next={fetchMore}
          hasMore={!articleEnded}
          loader={false}
          className="o-x-hidden o-y-hidden"
        >

          {!loadingNews && articles.length > 0 ? (
            <ArticleGridLayout
              isLoading={isPagination}
              articlesArray={articles}
              listview={listview}
            />
          ) : !loadingNews && articles.length === 0 ? (
            <Col span={24} className="article-grid width-100">
              <NoDataFound title={`${selectedFilters?.length
                ? NODATABASEDONFILTERS : NODATAFOUND}`}
              />
            </Col>
          ) : null}
        </InfiniteScroll>
      </div>
      {
        isPagination && !articleEnded && (
          <Row gutter={[16, 16]}>
            {listview ? (
              <ArticleListLoadingSkeletonBundle />
            ) : (
              <ArticleLoadingSkeletonBundle />
            )}
          </Row>
        )
      }
    </div>
  );
};

export default NewsTab;
